import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { CustomerInfoLoadIfNormalUserGuard } from 'app/core/guards/customer-info-load-if-normal-user.guard';
import { DependencyTreeGuard } from 'app/core/guards/dependency-tree.guard';
import { GetDefinitionsGuard } from '../../core/store/definitions/definitions.resolve';

import { BlankReceiptPageContainer } from './blank-receipt-page-container/blank-receipt-page.container';

const routes: Routes = [
  {
    path: 'blank-receipts',
    component: BlankReceiptPageContainer,
    canActivate: [DependencyTreeGuard],
    data: {
      guards: [GetDefinitionsGuard, CustomerInfoLoadIfNormalUserGuard],
    },
  },
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
})
export class BlankReceiptRoutingModule {}
